var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$emit('submit', _vm.value);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.value.nomeDaTurma,
      callback: function ($$v) {
        _vm.$set(_vm.value, "nomeDaTurma", $$v);
      },
      expression: "value.nomeDaTurma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Ano/Série",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listAnoSeries
    },
    model: {
      value: _vm.value.anoSerie,
      callback: function ($$v) {
        _vm.$set(_vm.value, "anoSerie", $$v);
      },
      expression: "value.anoSerie"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turno",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listTurnos
    },
    model: {
      value: _vm.value.turno,
      callback: function ($$v) {
        _vm.$set(_vm.value, "turno", $$v);
      },
      expression: "value.turno"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.filteredListEscolas
    },
    model: {
      value: _vm.value.escola,
      callback: function ($$v) {
        _vm.$set(_vm.value, "escola", $$v);
      },
      expression: "value.escola"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-submit-button'), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }